import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/Table';
import { Skeleton } from '@/components/ui/Skeleton';

type Props = {
  rows?: number;
  productTable?: boolean;
  noHeader?: boolean;
  testId?: string;
};

const SkeletonTable = ({
  rows = 4,
  productTable = false,
  noHeader,
  testId = 'skeleton-table',
}: Props) => {
  return (
    <div className='rounded-md border w-full'>
      <Table data-testid={testId}>
        {!noHeader && (
          <TableHeader>
            <TableRow>
              <TableHead>
                <Skeleton className='h-4 w-24' />
              </TableHead>
              <TableHead>
                <Skeleton className='h-4 w-24' />
              </TableHead>
              <TableHead>
                <Skeleton className='h-4 w-24' />
              </TableHead>
              <TableHead>
                <Skeleton className='h-4 w-24' />
              </TableHead>
            </TableRow>
          </TableHeader>
        )}
        <TableBody>
          {Array.from({ length: rows }).map((_, index) => (
            <TableRow key={index}>
              <TableCell>
                {productTable ? (
                  <div className='flex items-center gap-2'>
                    <Skeleton className='h-10 w-10 shrink-0 rounded-md' />
                    <Skeleton className='h-4 flex-1' />
                  </div>
                ) : (
                  <Skeleton className='h-4 w-full' />
                )}
              </TableCell>
              <TableCell>
                <Skeleton className='h-4 w-full' />
              </TableCell>
              <TableCell>
                <Skeleton className='h-4 w-full' />
              </TableCell>
              <TableCell>
                <Skeleton className='h-4 w-full' />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default SkeletonTable;
